import React from 'react';

import ChoiceLine from '../form-wrappers/choice-line';
import ByDayItem from '../form-items/byDay-item';
import * as recurrence from '../../../../constants/recurrence-constants';

const WeekdayChoice = ({ rootContainer, form, choiceObj }) => {
  return (
    <ChoiceLine
      form={form}
      suffix={null}
      sizes={choiceObj.sizes}
      prefix={{ isRadioGroup: choiceObj.isRadioGroup, label: 'Every week day(s)', value: choiceObj.choiceLineValue }}
    >
      <ByDayItem
        rootContainer={rootContainer}
        selectedChoice={choiceObj.selectedChoice}
        choiceLineValue={choiceObj.choiceLineValue}
        requiredItems={choiceObj.requiredItems}
        isRadioGroup={choiceObj.isRadioGroup}
        inputType={choiceObj.inputType}
      />
    </ChoiceLine>
  );
};
export default WeekdayChoice;
